module.exports = __webpack_public_path__ + "static/media/smartphones1.5f0fb959.png";